module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.9043/assets/images/app-milestone.png"